<script>
import Layout from "../../layouts/main";
// import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loader from "@/components/widgets/loader";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vue from "vue";
// import Vuetable from "vuetable-2";
// import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import {FulfillingBouncingCircleSpinner} from "epic-spinners";
// import { helpers } from "../../../../helpers/helpers-validate";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
// import MaskedInput from "vue-text-mask";
// import Switches from "vue-switches";

Vue.component("v-select", vSelect);
// register the plugin on vue
import Toasted from "vue-toasted";
import {
  authMethods,
  authFackMethods,
  notificationMethods
} from "@/state/helpers";
import {mapState} from "vuex";
import {authComputed} from "@/state/helpers";

Vue.use(Toasted);

export default {
  page: {
    title: "Corte de caja",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    Layout,
    DatePicker,

    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
  },
  data() {
    return {
      userT: this.$store.state.authfack.user,
      arrayUsuarios: [],
      datos: null,
      disabledUser: true,
      disabledDate: true,
      detalleprodutos: [],
      form: {
        fecha_inicio: null,
        fecha_final: null,
      },
      mask_quetzal: createNumberMask({
        prefix: "Q ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      // Otros datos
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token}
      },
      apiUrl: process.env.VUE_APP_URL,
      apiBase:
          process.env.VUE_APP_URL +
          "productos/stock/busqueda?departamento=" +
          0 +
          "&estante=" +
          0,
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      showModalL: false, //Loading
      showModalNP: false, //Nuevo cliente
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
    };
  },
  validations: {
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }


  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
   
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    detalle() {
    
      axios
        .get(process.env.VUE_APP_URL + "reportes/ventas_rango?fecha_inicio=" +
            this.form.fecha_inicio +
            "&fecha_fin=" +
            this.form.fecha_final, {
          headers: { "x-token": this.userT.token },
        })
        .then((response) => {
          this.detalleprodutos = response.data.rows;
          console.log('respuesta',this.detalleprodutos);
        });
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
            number.charAt(i) === "Q" ||
            number.charAt(i) === "€" ||
            number.charAt(i) === "$" ||
            number.charAt(i) === "%" ||
            number.charAt(i) === "," ||
            number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },

  },
};
</script>

<template>
  <Layout>
    <!-- Modal loading -->
    <b-modal
        centered
        v-model="showModalL"
        title-class="text-black font-18"
        body-class="p-3"
        hide-footer
        no-close-on-backdrop
        content-class="my-class"
        header-class="my-class"
    >
      <template #modal-header="{}">
        <!-- Emulate built in modal header close button action -->

        <h5></h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <fulfilling-bouncing-circle-spinner
                  :animation-duration="2000"
                  :size="90"
                  color="#2a3042"
              />
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- <PageHeader :title="title" :items="items" /> -->
    <!-- ESTA PARTE ES PARA LA CABECERA -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
            <div class="col-md-4"></div>
              <div class="col-md-4">
                <img
                  class="img-fluid float-right grises"
                  src="../../../../src/assets/images/logoZonaR.png"
                  alt="Logo"
              />
              </div>
              <div class="col-md-4">
                <div class="d-print-none">
                <div class="float-end">
                  <a
                    href="javascript:window.print()"
                    class="btn btn-primary w-md waves-effect waves-light me-1"
                    ><i class="fa fa-print"></i
                  ></a>
                </div>
              </div>
              </div>
            </div>
            <br />
            <div class="text-center">
              <div class="mb-4">
                <h3>Ventas por rango de fechas</h3>
              </div>
            </div>
            <div class="row" align="center">
              <div class="col">
              
              </div>
            </div>
            <hr/>
            <div class="text-center">
              <div>
                <div class="row">
              <div class="col-md-2"></div>
              <div class="col-md-3">
                <h5>Fecha Inicio</h5>
                <date-picker     
                        v-model="form.fecha_inicio"
                        @input="detalle"
                        placeholder="Seleccione una fecha de inicio"
                    ></date-picker>
              </div>
              <div class="col-md-2"></div>
              <div class="col-md-3">
                <h5>Fecha Final</h5>
                <date-picker     
                        v-model="form.fecha_final"
                        @input="detalle"
                        placeholder="Seleccione una fecha final"
                    ></date-picker>
              </div> 
              <div class="col-md-2"></div>            
                </div> 
                <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Venta</th>
                    <th>Cliente</th>
                    <th>Producto</th>
                    <th>cantidad</th>
                    <th>Departamento</th>
                    <th>Pasillo</th>
                    <th>Uicación</th>
                    <th>Proveedor</th>
                    <th>Usuario</th>
                    <th>Precio venta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, idx) in this.detalleprodutos"
                    v-bind:key="idx"
                  >
                    <td>
                      {{ item.venta.no_venta }}
                    </td>
                    <td>
                      {{ item.venta.cliente.persona.nombre_persona }}
                    </td>
                    <td>
                       {{ item.stock.producto.nombre_producto }}
                    </td>
                    <td>
                       {{ item.cantidad_venta }}
                    </td>
                    <td>
                      {{ item.detalle_departamento.estante.nombre_estante }}
                    </td>  
                    <td>
                      {{ item.detalle_departamento.estante.nombre_pasillo }}
                    </td>  
                    <td>
                      {{ item.detalle_departamento.departamento.nombre_departamento }}
                    </td>  
                    <td>
                      {{ item.stock.proveedore.company_proveedor }}
                    </td>
                    <td>
                      {{ item.venta.user.empleado.persona.nombre_persona}} {{  item.venta.user.empleado.persona.apellido_persona  }}
                    </td>
                    <td>
                       {{ money(item.precio_venta) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>            
                <!-- Seleccion-->            
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
.grises {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}

@media print {
  @page {
    margin: 0;
    size: auto;
  }
}
</style>